module.exports = __webpack_public_path__ + "img/Lessing_Ritterburg_anagoria.9c240a2d.png";